module.exports = __webpack_public_path__ + "img/logo_1.595afd72.jpg";